import HarnessList from '../../../components/vehicle/harness'
import HarnessListStore from '../../../components/vehicle/harness/context/context'

const HarnessListPage = () => {
  return (
    <HarnessListStore>
      <HarnessList />
    </HarnessListStore>
  )
}

export default HarnessListPage
